import Image from "next/legacy/image";
import Link from "next/link";
import { blurDataURL } from "../../../utils/constants/images";
import { GALLERIES_LIST_URL } from "../../../utils/constants/websiteUrls";
import Badge from "../../common/Badge";
import ClockIcon from "../../common/icons/ClockIcon";

const GalleryCard = ({ gallery }) => {
  return (
    <>
      <Link href={`${GALLERIES_LIST_URL}/${gallery.slug}`}>
        <div className="group relative transform transition duration-500 hover:scale-105">
          <div className="relative w-full bg-white aspect-w-1 aspect-h-1 rounded-md hover:opacity-75 overflow-hidden sm:aspect-w-2 sm:aspect-h-3">
            <Image
              src={gallery?.thumbnail}
              alt="Gallery Thumbnail"
              objectFit="cover"
              layout="fill"
              quality={100}
              placeholder="blur"
              blurDataURL={blurDataURL}
              className="absolute w-full h-full object-center object-cover"
            />

            <div
              aria-hidden="true"
              className="bg-gradient-to-b from-transparent to-black opacity-100 absolute inset-0"
            ></div>
            <div className="p-6 flex items-end justify-center absolute inset-0">
              {gallery?.category && (
                <Badge categoryName={gallery?.category.name} />
              )}
              <div>
                <h1 className="mt-2 mb-8 text-center font-semibold text-white text-base lg:text-xl xl:text-xl 2xl:text-xl break-words">
                  <span> {gallery?.title}</span>
                </h1>

                <span className="absolute bottom-3 left-[24px] text-center text-xs font-normal text-gray-400 break-words inline-flex justify-center items-center">
                  <ClockIcon />
                  {gallery?.time_ago}
                  <span
                    className="h-3 w-0.5 bg-gray-400 mr-2 ml-2"
                    aria-hidden="true"
                  ></span>
                  <span className="text-gray-400">
                    {gallery.group === "UNDER20" || gallery.group === "UNDER17"
                      ? "ACADEMY"
                      : gallery.group}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default GalleryCard;
